module.exports = __webpack_public_path__ + "img/wallimage.a3c7ce12.jpg";